module.exports = __webpack_public_path__ + "img/blue_059.bd51bef6.png";